import React from "react";
import PropTypes from "prop-types";
import _capitalize from "lodash/capitalize";
import { Modal } from "antd";

import { 
    CASE_UPGRADE_ACTIONS, 
    CASE_VIEW_ACTION 
} from "constants";
import ProceedModalContent from "./proceed-modal-content";
import ReferModalContent from "./refer-modal-content";
import RejectModalContent from "./reject-modal-content";
import AssignModalContent from "./assign-modal-content";
import HoldModalContent from "./hold-modal-content";
import OpenModalContent from "./open-modal-content";
import { OrderedMap } from "immutable";


const REJECT_REASONS = new OrderedMap({
    "Poor CIBIL": "Poor CIBIL",
    "Outstanding Pending": "Outstanding Pending",
    "Length of Business is Poor/ Low Sales": "Length of Business is Poor/ Low Sales",
    "Document Pending": "Document Pending",
    "Others": "Others"
});

class CaseActionModal extends React.Component {
    state = {
        modalVisible: false,
        data: CASE_UPGRADE_ACTIONS.toSeq()
            .map(() => null)
            .toJS(),
        requestedDocuments: []
    };

    referRef = React.createRef();
    onChange = (action, data, requestedDocuments) =>
        this.setState({
            data: { ...this.state.data, [action]: data },
            requestedDocuments: requestedDocuments
        });

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.action &&
            nextProps.action !== CASE_VIEW_ACTION &&
            (nextProps.caseId || nextProps.caseIds)
        ) {
            this.toggleModal();
        }
    }

    getModalTitle = action => {
        switch (action) {
        case CASE_UPGRADE_ACTIONS.PROCEED:
        case CASE_UPGRADE_ACTIONS.PROCEED_BULK_CASES:
            return _capitalize(CASE_UPGRADE_ACTIONS.PROCEED);
        case CASE_UPGRADE_ACTIONS.REFER:
            return _capitalize(CASE_UPGRADE_ACTIONS.REFER);
        case CASE_UPGRADE_ACTIONS.REJECT:
            return _capitalize(CASE_UPGRADE_ACTIONS.REJECT);
        case CASE_UPGRADE_ACTIONS.ASSIGN:
            return _capitalize(CASE_UPGRADE_ACTIONS.ASSIGN);
        case CASE_UPGRADE_ACTIONS.REASSIGN:
            return _capitalize(CASE_UPGRADE_ACTIONS.REASSIGN);
        case CASE_UPGRADE_ACTIONS.UNASSIGN:
            return _capitalize(CASE_UPGRADE_ACTIONS.UNASSIGN);
        case CASE_UPGRADE_ACTIONS.HOLD:
            return _capitalize(CASE_UPGRADE_ACTIONS.HOLD);
        case CASE_UPGRADE_ACTIONS.OPEN:
            return _capitalize(CASE_UPGRADE_ACTIONS.OPEN);
        case CASE_UPGRADE_ACTIONS.PULL_BACK_TO_PS_KIT:
                return _capitalize("Pull Back To Ps-Kit");    
        default:
            return null;
        }
    };

    getModalConfirmAction = action => () => {
        if (action === "REJECT") {
            this.referRef.current.validateFields(err => {
                if (!err) {
                    this.toggleModal();
                    this.props.history.replace(this.props.location.pathname, {
                        ...this.props.location.state,
                        case_actions: {}
                    });
                    this.props.upgradeCase(
                        action,
                        this.props.caseTaskId,
                        this.props.caseId,
                        this.state.data[action],
                        this.props.stageName || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stageName),
                        this.props.stageId || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stage_id),
                    );
                }
            });
        } else if (["HOLD", "OPEN"].includes(action)) {
            this.toggleModal();
            this.props.history.replace(this.props.location.pathname, {
                ...this.props.location.state,
                case_actions: {}
            });
            this.props.upgradeCase(
                action,
                this.props.caseTaskId,
                this.props.caseId,
                this.state.data[action],
                this.props.stageName || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stageName),
                this.props.stageId || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stage_id),
            );
        }
        else if(
            (action === "ASSIGN" || action === "REASSIGN")
        ) {
            const path = this.props.location &&
                this.props.location.state &&
                this.props.location.state.case_actions &&
                this.props.location.state.case_actions.params;
            this.props.history.replace(path, {
                ...this.props.location.state,
                updated: true,
                case_actions: {},
                disableActionButton: false
            });
            this.props.upgradeCase(
                action,
                this.props.caseTaskId,
                this.props.caseId,
                this.state.data[action],
                this.props.stageName || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stageName),
                this.props.stageId || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stage_id),
                action === "ASSIGN" ? "unassigned" : "all",
                path
            );

            this.setState({
                data: CASE_UPGRADE_ACTIONS.toSeq()
                    .map(() => null)
                    .toJS(),
                modalVisible: false
            });
        }
        else {
            this.toggleModal();
            this.props.closeActionModal ? this.props.closeActionModal() : null;
            this.props.history.replace(this.props.location.pathname, {
                ...this.props.location.state,
                case_actions: {},
                disableActionButton: false
            });
            this.props.upgradeCase(
                action,
                this.props.caseTaskIds || this.props.caseTaskId,
                this.props.caseId,
                this.state.data[action],
                this.props.stageName || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stageName),
                this.props.stageId || (this.props.location.state && this.props.location.state.case_actions && this.props.location.state.case_actions.stage_id),
                this.props.selectedCasesType
            );

            this.setState({
                data: CASE_UPGRADE_ACTIONS.toSeq()
                    .map(() => null)
                    .toJS(),
                modalVisible: false
            });

        }
    };
    getModalContent = action => {
        switch (action) {
        case CASE_UPGRADE_ACTIONS.BULK_PROCEED:
            return (
                <ProceedModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                />
            );
        case CASE_UPGRADE_ACTIONS.PROCEED_BULK_CASES:
        case CASE_UPGRADE_ACTIONS.PROCEED:
            return (
                <ProceedModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                />
            );
        case CASE_UPGRADE_ACTIONS.REFER:
            return (
                <ReferModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                    companyId={this.props.companyId}
                />
            );
        case CASE_UPGRADE_ACTIONS.BULK_REFER:
            return (
                <ReferModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                />
            );
        case CASE_UPGRADE_ACTIONS.REJECT:
            return (
                <RejectModalContent
                    ref={this.referRef}
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    rejectReason={REJECT_REASONS}
                    stage={this.props.stageName}
                />
            );
        case CASE_UPGRADE_ACTIONS.REASSIGN:
        case CASE_UPGRADE_ACTIONS.ASSIGN:
            return (
                <AssignModalContent
                    onChange={this.onChange.bind(null, action)}
                    caseId={this.props.caseId}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    isStageAdmin={false}
                    type={"assign"}
                />
            );
        case CASE_UPGRADE_ACTIONS.UNASSIGN:
            return (
                <AssignModalContent
                    onChange={this.onChange.bind(null, action)}
                    caseId={this.props.caseId}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    isStageAdmin={false}
                    type={"unassign"}
                />
            );
        case CASE_UPGRADE_ACTIONS.HOLD:
            return (
                <HoldModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                />
            );
        case CASE_UPGRADE_ACTIONS.OPEN:
            return (
                <OpenModalContent
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                />
            );
        case CASE_UPGRADE_ACTIONS.PULL_BACK_TO_PS_KIT:
            return (
                <ReferModalContent
                    removeStageSelection={true}
                    onChange={this.onChange.bind(null, action)}
                    stageId={this.props.stageId}
                    stage={this.props.stageName}
                    caseId={this.props.caseId}
                    companyId={this.props.companyId}
                />
            );
        default:
            return null;
        }
    };
    toggleModal = () => {
        this.setState({
            modalVisible: !this.state.modalVisible
        });
    }
    onModalCancel = () => {
        this.setState(
            {
                modalVisible: false,
                data: CASE_UPGRADE_ACTIONS.toSeq()
                    .map(() => null)
                    .toJS()
            },
            () =>
                this.props.history.replace(this.props.location.pathname, {
                    ...this.props.location.state,
                    case_actions: {},
                    disableActionButton: false
                })
        );
    };

    render() {
        const { action } = this.props;
        const { modalVisible } = this.state;
        if (
            (!this.props.caseId || !this.props.caseIds) &&
            !this.props.stageId &&
            (!this.props.caseTaskId || !this.props.caseTaskIds)
        ) {
            return null;
        }
        return (
            <Modal
                title={this.getModalTitle(action)}
                visible={modalVisible}
                destroyOnClose={true}
                onOk={this.getModalConfirmAction(action)}
                onCancel={this.onModalCancel}
                okButtonProps={{
                    disabled: !this.state.data[action]
                }}
                closable
                maskClosable
            >
                {this.getModalContent(action)}
            </Modal>
        );
    }
}

CaseActionModal.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    action: PropTypes.string,
    upgradeCase: PropTypes.func,
    closeActionModal: PropTypes.func,
    stageName: PropTypes.string,
    caseIds: PropTypes.array,
    stageId: PropTypes.number,
    selectedCasesType: PropTypes.string,
    caseId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    caseTaskId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
    caseTaskIds: PropTypes.array,
    filters: PropTypes.object,
    page: PropTypes.number,
    pageSize: PropTypes.number,
    associates: PropTypes.array,
    companyId: PropTypes.number,
    requestDocuments: PropTypes.func
};

export default CaseActionModal;
